import { lazyNamed } from 'src/utils/lazyNamed';

export { AdMedias } from './containers/AdMedias';
export { Placements } from './containers/Placements';
export { AdTypes } from './containers/AdTypes';
export { Products } from './containers/Products';
export { AdPrices } from './containers/AdPrices';
export { Calendars } from './containers/Calendars';
export { SizeConfigs } from './containers/SizeConfigs';
export { Availabilities } from './containers/Availabilities';

export const Layout = lazyNamed(() => import('./components/Layout'), 'Layout');
